export function castBio() {

        const readMoreButtons = document.querySelectorAll('.site-cast__bio-read-more');
        readMoreButtons.forEach(button => {
            button.addEventListener('click', function() {
                const bio = this.previousElementSibling;
                bio.classList.toggle('expanded');
                if (bio.classList.contains('expanded')) {
                    this.textContent = 'Read less';
                } else {
                    this.textContent = 'Read more';
                }
            });
        });
    

        const castMembers = document.querySelectorAll('.site-cast__member');
        castMembers.forEach(member => {
            member.addEventListener('mouseenter', function() {
                if (window.innerWidth > 980) {
                    this.classList.add('flipped');
                }
            });
            member.addEventListener('mouseleave', function() {
                if (window.innerWidth > 980) {
                    this.classList.remove('flipped');
                }
            });
        });
}